import TripPlanningType, {
  type TripPlanningType as TripPlanningTypeValue,
} from '$/_const/trip/TripPlanningType.ts';

type PlanningTypeSource = {
  trip_planning_type?: TripPlanningTypeValue | null;
  trip_destination?: string | null;
};

const initialPlanningType = (trip?: PlanningTypeSource | null): TripPlanningTypeValue | undefined => {
  if (trip?.trip_planning_type) {
    return trip.trip_planning_type;
  }

  return trip?.trip_destination?.trim() ? TripPlanningType.DESTINATION_IN_MIND : undefined;
};

type DestinationStepSaveState = {
  isDirty: boolean;
  loadedPlanningType?: TripPlanningTypeValue | null;
  submittedPlanningType?: TripPlanningTypeValue | null;
};

export const shouldSaveDestinationStep = ({
  isDirty,
  loadedPlanningType,
  submittedPlanningType,
}: DestinationStepSaveState): boolean => isDirty || (!loadedPlanningType && !!submittedPlanningType);

export default initialPlanningType;
